module.exports = __webpack_public_path__ + "static/media/inplayer-icon-large.c0d862c4.svg";